import {Component, Input} from '@angular/core';
import {Group} from "../../model/group";
import {ModalsService} from "../../services/modals.service";

@Component({
  selector: 'app-group-info-modal',
  templateUrl: './group-info-modal.component.html',
  styleUrls: ['./group-info-modal.component.css']
})
export class GroupInfoModalComponent {
  @Input() group: Group;

  constructor(private readonly modalsService: ModalsService) {
  }

  close(): void {
    this.modalsService.hideModal();
  }

  edit(): void {
    this.modalsService.showEditGroup(this.group);
  }

  delete(): void {
    this.modalsService.showDeleteGroup(this.group);
  }
}
